<template>
  <div>
    <v-form @submit="() => {}" v-model="valid" ref="form">
      <v-autocomplete
        :readonly="readonly"
        v-model="model"
        :items="items"
        :loading="loading"
        :search-input.sync="search"
        :color="color"
        hide-no-data
        hide-selected
        :item-text="itemText"
        :item-value="itemValue"
        :label="label"
        :placeholder="placeholder"
        :prepend-icon="prependIcon"
        :multiple="multiple"
        @input="sendInput($event, itemValue);
                $emit('change',$event);"
        :clearable="readonlyComp"
        return-object
        :rules="rules ? rules : []"
        no-filter
      ></v-autocomplete>
    </v-form>
  </div>
</template>

<script>
export default {
  props: [
    "value",
    "itemPreSelected",
    "itemText",
    "itemValue",
    "label",
    "placeholder",
    "prependIcon",
    "color",
    "entityApi",
    "fieldApi",
    "clearable",
    "rules",
    "readonly",
    "multiple"
  ],
  computed: {
    readonlyComp() {
      return this.model != null;
    },
  },
  watch: {
    value() {
      this.$refs.form.resetValidation();
      if (!this.value) {
        this.itemPreSelectedModel = null;
      }
    },


    async search(val) {
      if (!val || this.isBusy)  return;
      if (this.itemPreSelectedModel && val == this.itemPreSelectedModel[this.itemText]){
        return;
      }
      // let value = "";
      // Object.assign(value, val);
      // val = null;
      // val = value;
      //console.log(val)
      this.loading = true;
      let res = await this.$http.get(`autocomplete/${this.entityApi}`, {
        field: this.fieldApi,
        value: val,
      });

      if (res.success) {
        this.items = res.data;
      }
      this.loading = false;
    },
    filterAutoComplete(item, queryText, itemText) {
      let split = itemText.split(",");
      if (split.length == 1)
        return (
          itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) >
          -1
        );
    },
    itemPreSelected(value) {
      this.items = [];
      this.model = null;
      if (value != null && value != {}) {
        this.isBusy = true;
        this.items = [];
        this.model = value.id;
        this.itemPreSelectedModel = value;
        this.items.push(this.itemPreSelectedModel);
        this.isBusy = false;
      }
    },
  },
  data() {
    return {
      valid: false,
      model: null,
      items: [],
      loading: false,
      search: "",
      itemPreSelectedModel: null,
      isBusy: false,
      selectJobId: null
    };
  },
  methods: {
    isValid() {
      return this.$refs.form.validate();
    },
    sendInput(event, itemValue){
      console.log("Item Value >>> ", itemValue)

      if(this.multiple){
        let items = event.map((item) => {
          return item[itemValue]
        }).join(",").toString()

        this.$emit('input', `${items}`);
        return
      }

      this.$emit('input', event ? event[itemValue] : null);
    }
  },
  mounted() {},
};
</script>
